import { DevModalActionType } from '../../types/devModalType'

export const closeDevModal = () => {
    return {type: DevModalActionType.CLOSE_DEV_MODAL}
}

export const openDevModal = () => {
    return {type: DevModalActionType.OPEN_DEV_MODAL}
}